import { EventBus } from 'quasar';

const bus = new EventBus();
const useEventBus = () => {
  return bus;
};

export { bus, useEventBus };